export default __webpack_public_path__ + "static/about_menu-e2fb663f9c0a3acba7979006c15818ce.png";